<template>
    <el-dialog
        class="share-dialog"
        :visible.sync="shareDialogShow"
        width="375px"
    >
        <div class="slot-title" slot="title">
            <div class="slot-title-top">{{$t('Share_Master_Account')}}</div>
            <div class="slot-title-bot" v-if="detailData.flag">{{$t('Develop_your_customers_through_poster_links')}}</div>
        </div>
        <div class="content">
            <el-scrollbar style="height: 100%;">
                <div class="poster" ref="poster">
                    <div class="account-info bgimg-cover bg-position-center no-repeat">
                        <div class="logo-outer">
                            <img width="120" src="../../assets/images/logo/logo_white_new.png" alt="">
                        </div>
                        <div class="info-top">
                            <span class="alias">{{detailData.alias}}</span>
                            <span class="share-tag">{{detailData.businessType == 1 ? 'Social' : 'MAM'}} {{$t('Master_account')}}</span>
                        </div>
                        <div class="info-bot">
                            {{detailData.login}}
                        </div>
                        <div class="share-master">
                            {{editUserName}}{{$t('recommend')}}
                        </div>
                    </div>
                    <div class="over-box">
                        <div class="over-box-inner">
                            <div class="index-module">
                                <div class="earnings index-item">
                                    <div class="index-item-top">{{$t('share_rate_of_return')}}</div>
                                    <div
                                            class="index-item-bot rate"
                                            :class="{on: isIncludeMinus(detailData.profitRate)}"
                                    >{{detailData.profitRate}}</div>
                                </div>
                                <div class="return index-item">
                                    <div class="index-item-top">{{$t('share_threeMonthsReturn')}}</div>
                                    <div class="index-item-bot">{{detailData.maxRetracement}}</div>
                                </div>
                                <div class="tradingtime index-item">
                                    <div class="index-item-top">{{$t('contractDetailed.tradingHour')}}</div>
                                    <div class="index-item-bot">{{detailData.transferPeriod}}{{$t('day')}}</div>
                                </div>
                            </div>
                            <div
                                    ref="sharechartup"
                                    class="chart-box pc-padtop30-mobil-padtop20"
                            >
                                <account-bar
                                        :chart-width="echarWidth"
                                        :height="echarHeight"
                                        :chart-list="levelData"
                                ></account-bar>
                            </div>
                            <div class="rate-box center">
                                <el-rate
                                        disabled
                                        :value="detailData.recommendStar"
                                        show-score
                                        :colors="[orange,orange,orange]"
                                        text-color="#999999"
                                ></el-rate>
                            </div>
                        </div>
                    </div>
                    <div class="over-other">
                        <div
                                v-if="detailData.tradeStrategy"
                                class="strategy">
                            <h3 class="fs14 blod font333 mar-bot10">{{$t('Strategy_description')}}</h3>
                            <p class="strategy-text">{{detailData.tradeStrategy}}</p>
                        </div>
                        <div
                                v-if="detailData.orderList.length"
                                class="recently-five">
                            <div class="five-title">{{$t('Close_to_5_liquidations')}}</div>
                            <div class="five-list">
                                <div
                                        v-for="(item,index) in detailData.orderList"
                                        :key="index"
                                        class="five-item">
                                    <div
                                            class="five-item-left">
                                        <div class="five-item-left-top mar-bot10">
                                            <span class="symbol">{{item.symbol}}</span>
                                            <span
                                                    class="cmd"
                                                    :class="{on:  item.cmd  == 1 }"
                                            >{{item.cmd  == 0 ? $t('User.buy') : $t('User.sell')}}</span>
                                        </div>
                                        <div class="five-item-left-bot font999">
                                            <span class="openPrice">{{item.openPrice}}</span>
                                            <span class="el-icon-right"></span>
                                            <span class="closePrice">{{item.closePrice}}</span>
                                        </div>
                                    </div>
                                    <div class="five-item-right">
                                        <div class="profit mar-bot10" :class="{on: isIncludeMinus(item.profit)}">{{item.profit}}</div>
                                        <div class="volume font999">{{item.lot}}{{$t('Home.forexLot')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="qr-module">
                            <img
                                    :src="detailData.qrForShare"
                                    alt=""
                                    class="qr-img"
                            >
                            <div class="qr-text">
                                <div class="qr-title">
                                    <span class="font333">Maxain</span>
                                    <span class="theme-color">{{$t('Investment_community')}}</span>
                                </div>
                                <div class="qr-desc">{{$t('Sweep_code_to_follow_the_master_profit_together')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="self-footer">
               <el-row :gutter="10">
                   <el-col :span="12">
                       <el-button class="share-do-btn copylink-btn" @click="copyLinkHandle">{{$t('copylink')}}</el-button>
                   </el-col>
                   <el-col :span="12">
                       <el-button class="share-do-btn" type="primary" @click="productImgHandle">{{$t('Save_as_a_poster')}}</el-button>
                   </el-col>
               </el-row>
            </div>
        </div>
    </el-dialog>
</template>

<style lang="scss" scoped>
    @import "../../assets/scss/variable";
    .share-dialog {
        .slot-title {
            .slot-title-top {
                font-size: 16px;
                color: #333333;
                font-weight: bold;

            }
            .slot-title-bot {
                font-size: 12px;
                color: #666666;
                margin-top: 10px;
            }
        }
        .content {
            max-height: 680px;
            height: 680px;
            position: relative;
            .account-info {
                position: relative;
                height: 294px;
                padding: 20px 15px 0 15px;
                background-image: url('../../assets/images/newUserCenter/sharebg.png');
                color: #ffffff;
                .logo-outer {
                    margin-bottom: 50px;
                }
                .info-top {
                    margin-bottom: 10px;
                }
                .alias {
                    font-size: 24px;
                    display: inline-block;
                    margin-right: 10px;
                }
                .share-tag {
                    padding: 5px 10px;
                    background: rgba(255,255,255, .1);
                    border-radius: 12px;
                    font-size: 12px;
                }
                .info-bot {
                    font-size: 16px;
                }
                .share-master {
                    background-color: $themeGreen;
                    color: #ffffff;
                    height: 28px;
                    padding: 0 10px;
                    line-height: 28px;
                    text-align: center;
                    font-size: 14px;
                    position: absolute;
                    right: 0;
                    top: 50px;
                    border-bottom-left-radius: 14px;
                    border-top-left-radius: 14px;
                }
            }
            .over-box,
            .over-other {
                top: -110px;
            }
            .over-box {
                padding: 0 15px;
                height: 350px;
                position: relative;
                .over-box-inner {
                    border-radius: 5px;
                    background-color: #ffffff;
                    padding-bottom: 20px;
                    box-shadow: 0px 10px 50px 0px rgba(102, 77, 76, 0.1);
                    .index-module {
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        padding-top: 25px;
                        .index-item {
                            text-align: center;
                            .index-item-top {
                                font-size: 12px;
                                color: #999999;
                                margin-bottom: 10px;
                            }
                            .index-item-bot {
                                font-size: 20px;
                                color: #333333;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
            .rate,
            .profit {
                color: $themeGreen!important;
                &.on {
                    color: $themeColor!important;
                }
            }
            .openPrice,
            .closePrice {
                font-size: 12px;
                font-weight: 400;
            }
            .five-item-right {
                text-align: right;
                .profit {
                    font-weight: 600;
                    font-size: 14px;
                }
                .volume {
                    font-weight: 400;
                    font-size: 12px;
                }
            }
            .over-other {
                position: relative;
                padding: 0 15px;
                .strategy-text {
                    font-size: 14px;
                    color: #666666;
                    margin-bottom: 30px;
                }
            }
            .recently-five {
                .five-title {
                    font-weight: bold;
                    font-size: 18px;
                    margin-bottom: 30px;
                    color: #333333;
                }
                .five-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #F1F1F1;
                    padding-bottom: 10px;
                    margin-bottom: 10px;
                    .symbol {
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .cmd {
                        padding: 2px 8px;
                        border-radius: 10px;
                        background-color: $themeGreen;
                        font-size: 12px;
                        color: #ffffff;
                        &.on {
                            background-color: $themeColor;
                        }
                    }
                }
            }
            .qr-module {
                text-align: center;
                padding-top: 30px;
                .qr-img {
                    margin-bottom: 20px;
                    width: 120px;
                }
                .qr-title {
                    font-size: 16px;
                    margin-bottom: 5px;
                    font-weight: bold;
                }
                .qr-desc {
                    font-size: 12px;
                }
            }
            .self-footer {
                position: absolute;
                left: 0;
                bottom: 20px;
                width: 100%;
                padding: 0 15px;
                .share-do-btn {
                    width: 100%;
                }
            }
            .copylink-btn {
                &:focus {
                    color: #606266;
                    border-color: #DCDFE6;
                    background-color: #ffffff;
                }
            }
        }
    }
    @media screen and (max-width: 768px){
        .share-dialog {
            .content {
                height: 80vh;
            }
        }
    }
</style>
<script>
    import { queryShareInfo } from '@/api/copy'
    import { mapGetters } from 'vuex'
  import html2canvas from 'html2canvas';
  import copy from 'copy-to-clipboard';
    import { isIncludeMinus } from '@/utils/common'
    import accountBar from '@/components/echarts/accountBar'
  export default {
    name: 'shareDialog',
    components:{
      accountBar
    },
    data() {
      return {
        shareDialogShow: false,
        echarWidth: 184,
        echarHeight: 184,
        orange: '#FF7F5A',
        detailData:{
          alias: '',
          login: '',
          businessType: 1,
          profitRate: '',
          maxRetracement: '',
          transferPeriod: '',
          recommendStar: 0,
          tradeStrategy: '',
          orderList: [],
          qrForShare: '',
          linkForShare: '',
          flag: false,
        },
        levelData: [],
      };
    },
    computed: {
      ...mapGetters(['userInfo']),
      editUserName(){
        // if((this.userInfo.firstName + this.userInfo.lastName).length <= 3){
        //   return this.userInfo.firstName + this.userInfo.lastName;
        // }else {
        //   return (this.userInfo.firstName + this.userInfo.lastName).slice(0,3) + '...';
        // }
        return (this.userInfo.firstName + this.userInfo.lastName).slice(0,1) + '...';
      }
    },
    watch:{
      shareDialogShow(newValue){
        if(newValue){
          this.getInfoData();
          this.$nextTick(() => {
            this.echarWidth = this.$refs.sharechartup.clientHeight;
          });
        }
      }
    },
    methods: {
      isIncludeMinus,
      copyLinkHandle(){
        copy(this.detailData.linkForShare);
        this.$message({
          message: this.$t('Duplicated_link_go_share_it'),
          type: 'success'
        });
      },
      productImgHandle(){
        html2canvas(this.$refs.poster,{
          backgroundColor: '#ffffff',
          scrollY: 0,
        }).then((canvas) => {
          let dataURL = canvas.toDataURL("image/jpg");
          this.$emit('send-imgurl', dataURL);
          const link = document.createElement('a');
          link.href = dataURL;
          link.download = "share.jpg";
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          this.$message({
            message: this.$t('The_poster_has_been_generated_please_share_it'),
            type: 'success'
          })
        })
      },
      getInfoData(){
        queryShareInfo({mtId: this.$route.params.mtid}).then((res) => {
          this.detailData = res.data;
          this.levelData.push(res.data.profitAbility || 0);
          this.levelData.push(res.data.robustAbility || 0);
          this.levelData.push(res.data.riskControlAbility || 0);
          this.levelData.push(res.data.capitalSize || 0);
          this.levelData.push(res.data.tradingActivity || 0);
        })
      },
    }
  };
</script>
<style lang="scss">
    .share-dialog {
        .el-dialog {
            margin-top: 7%!important;
            border-radius: 10px;
            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-top: 10px;
                padding-bottom: 0;
            }
        }
    }
</style>
